import { RouteConfig } from 'vue-router'

import InstagramInstantwinPrize from './pages'

export const instagramInstantwinPrize: RouteConfig = {
  component: InstagramInstantwinPrize,
  path: '/instagram_instantwins/:campaignId/prizes',
  name: 'instagram_instantwin_prizes'
}
